import { observer } from 'mobx-react-lite'
import React from 'react'

import { useGameContext } from '@/pages/game/context/game-context'
import StoreService from '@/store/StoreService'

import { JumbotronVideo } from './JumbotronVideo'

export const JumbotronVideoMusic = observer(
  function JumbotronVideoMusic(): React.ReactElement | null {
    const { gameData, isCreatedGame } = useGameContext()

    if (gameData.type !== 'music') return null

    const { currentItemIndex, drawnItems, sourcePlaylistMeta } = gameData

    const getVideoUrl = () => {
      const { host } = StoreService.getStore()

      if (isCreatedGame) {
        const playlistVideo = sourcePlaylistMeta?.videoPreGame?.url
        const brandingVideo = host?.settings?.branding?.jumbotron?.videoPreGame?.url

        return playlistVideo || brandingVideo
      }

      if (currentItemIndex === null) return

      const playlistVideo = sourcePlaylistMeta?.video?.url
      const songVideo = drawnItems[currentItemIndex].song?.video?.url
      const brandingVideo = host?.settings?.branding?.jumbotron?.video?.url

      return songVideo || playlistVideo || brandingVideo
    }

    const url = getVideoUrl()

    if (!url) return null

    return <JumbotronVideo url={url} />
  }
)
